export const LICENSE = {
  PLATINUM: {
    licenseType: 'PLATINUM',
    textKey: 'BQUI_BQA_PLAN_NAME_PLATINUM',
  },
  PREMIUM: {
    licenseType: 'PREMIUM',
    textKey: 'BQUI_BQA_PLAN_NAME_PREMIUM',
  },
  ENTERPRISE: {
    licenseType: 'ENTERPRISE',
    textKey: 'BQUI_BQA_PLAN_NAME_ENTERPRISE',
  },
  // SELF_SERVICE is not a real License type
  SELF_SERVICE: {
    licenseType: 'SELF_SERVICE',
    textKey: 'BQUI_BQA_PLAN_NAME_TRIAL',
  },
};

export const LICENSES = [LICENSE.PREMIUM, LICENSE.PLATINUM, LICENSE.ENTERPRISE, LICENSE.SELF_SERVICE];
